const middlewareTransactionName = "middleware";

export const excludedTransactionNames: (string | RegExp)[] = [
  middlewareTransactionName,
];
